<p-dialog [(visible)]="closeDeleteModalVisible" [style]="{width: '35vw'}" (onHide)="reloadHardCopyDetail()" >
    <ng-template pTemplate="header">
       <b> Delete Hardcopy Activity</b>
    </ng-template>
    <div *ngIf="errorMessages.length > 0">
        <p-messages severity="error">
          <ng-template pTemplate>
            <span class="p-message-icon pi pi-times-circle"></span>
            <span class="p-ml-2"
              >Please correct the following errors.</span>
            <ul>
              <li *ngFor="let errorText of errorMessages">{{ errorText }}</li>
            </ul>
          </ng-template>
        </p-messages>
      </div>
    <p>You are about to delete a Hardcopy Activity. This action is not reversible. Do you want to proceed?</p>
    <div class="col">
        <div class="field">
            <bpt-text-input label="Reason*"  
                 id="reason"  placeholder="Reason" [(ngModel)]="ReasonData" >
            </bpt-text-input>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <p-button appPreventDoubleClick label="Confirm" type="submit" id="confirmButton" [disabled]="ReasonData.trim()  === '' "  (debounceClick)="confirmClick($event)" class="align-right" >
        </p-button>
        <p-button appPreventDoubleClick styleClass="p-button-outlined" label="Cancel" type="submit" id="cancelButton" (debounceClick)="cancelClick()" class="align-right" >
        </p-button>
    </ng-template>
</p-dialog>
